import React, { useMemo } from 'react';
import trans from 'translate';
import PropTypes from 'prop-types';
import SliderToken from './SliderToken/SliderToken';

import EmptyIcon from '../EmptyIcon';
import './SliderTokensList.scss';

const SliderTokensList = ({
  tokens,
  allTokens,
  handleTokenSliderChange,
  handleTokenLock,
  handleTokenDelete,
  sliderCheck,
  ethLeftover,
  actionCol,
  editMode,
}) => {
  const allDeletesDisabled = useMemo(() => tokens.every(({ deleteDisabled }) => deleteDisabled), [tokens]);
  return (
    <div className="slider-tokens-list-wrapper">
      {tokens.length > 0 ? (
        <>
          <div className="sections-titles-wrapper">
            <div className="section-title first-section">{trans('common.token_name')}</div>
            <div className="section-title middle-section">{trans('common.allocation')}</div>
            <div className="section-title last-section">
              {/* {allDeletesDisabled ? trans('common.lock') : trans('pools.lock_and_delete')} */}
              {trans(actionCol.title)}
            </div>
          </div>

          <div className="slider-tokens-wrapper">
            {tokens.map((token) => (
              <SliderToken
                handleTokenSliderChange={handleTokenSliderChange}
                handleTokenLock={handleTokenLock}
                handleTokenDelete={handleTokenDelete}
                sliderCheck={sliderCheck}
                key={token.symbol || token.token_id}
                token={token}
                allTokens={allTokens}
                ethLeftover={ethLeftover}
                renderedAction={actionCol.render}
                editMode={editMode}
              />
            ))}
          </div>
        </>
      ) : (
        <div className="slider-empty-state">
          <EmptyIcon />
          {trans('pools.choose_tokens_no_tokens')}
        </div>
      )}
    </div>
  );
};

SliderTokensList.propTypes = {
  editMode: PropTypes.bool,
  tokens: PropTypes.array.isRequired,
  allTokens: PropTypes.array.isRequired,
  ethLeftover: PropTypes.number.isRequired,
  handleTokenSliderChange: PropTypes.func.isRequired,
  handleTokenLock: PropTypes.func.isRequired,
  handleTokenDelete: PropTypes.func.isRequired,
  sliderCheck: PropTypes.func.isRequired,
  actionCol: PropTypes.object.isRequired,
};

SliderTokensList.defaultProps = {
  editMode: false,
};

export default SliderTokensList;
